// extracted by mini-css-extract-plugin
export default {"actions":"Ingresos_actions__-y323","link":"Ingresos_link__I2Y3+"};